// extracted by mini-css-extract-plugin
module.exports = {"name":"ItemModal_name__2a-p0","price":"ItemModal_price__3oKVb","img":"ItemModal_img__XkfFB"};